import React, { useState, useMemo, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { StickyTable, Row as StickyRow, Cell } from 'react-sticky-table';
import { Scrollbars } from 'react-custom-scrollbars';
import { NavLink } from 'react-router-dom';

import { Text, Button } from 'Component/Ajaib';
import useDiscoveryGroupMemberList from '@services/stock/global/discovery/groupMember';

import { useLoginPin } from '@hooks/auth';
import { useUserData } from '@services/users/me';

import styles, { styHeaderCol } from './style';
import DashboardStockContent from './Content';
import useEventTracker from './tracker';

const DashboardStock = () => {
  const { userData } = useUserData();
  const { isUserNotOnThePinScreen } = useLoginPin();

  const { eventClickStockCategory } = useEventTracker();

  const [activeFilter, setActiveFilter] = useState('active');
  const filterButtons = [
    { text: 'Top Volume', key: 'active', groupCode: 'TopVolumeRG' },
    { text: 'Top Gainer', key: 'gainer', groupCode: 'TopGainerRG' },
    { text: 'Top Loser', key: 'loser', groupCode: 'TopLoserRG' },
  ];
  const findFilter = filterButtons.find((b) => b.key === activeFilter);

  const { groupCode } = findFilter || {};
  const { data: dataList } = useDiscoveryGroupMemberList({
    groupCode,
    pageSize: 50,
    enabled: !!userData?.user_info && isUserNotOnThePinScreen && !!findFilter,
  });

  const onClickFilter = useCallback((e) => {
    const { text, key } = e.target.dataset;
    setActiveFilter(key);
    const eventProps = {
      tab: text,
    };
    eventClickStockCategory(eventProps);
  });
  const results = useMemo(() => {
    const res = dataList || [];
    return res.length > 20 ? res.slice(0, 20) : res;
  }, [activeFilter, dataList]);
  const isNotation = results.some((res) => res.special_notations?.length > 0);

  const headerContents = [
    {
      text: 'Kode',
      className: styHeaderCol,
      width: '24%',
    },
    { text: 'Notasi', className: styHeaderCol, width: '18%' },
    {
      text: 'Volume',
      type: 'number',
      className: `${styHeaderCol} text-right`,
      width: isNotation ? '16%' : '26%',
    },
    {
      text: 'Harga',
      type: 'number',
      className: `${styHeaderCol} text-right`,
      width: isNotation ? '17%' : '20%',
    },
    {
      text: 'Change',
      type: 'number',
      className: `${styHeaderCol} text-right`,
      width: isNotation ? '25%' : '30%',
    },
  ];
  const headers = isNotation
    ? headerContents
    : headerContents.filter((header) => header.text !== 'Notasi');

  return (
    <>
      <Row>
        <Col className="d-flex justify-content-between align-items-center">
          <div>
            <Text size="section" bold>
              Saham Teraktif
            </Text>
          </div>
          <div>
            <NavLink end to={`/home/stocks?active=${findFilter.groupCode}`}>
              <Button variant="sentence" size="sm" data-testid="btnStockMore">
                Selengkapnya
              </Button>
            </NavLink>
          </div>
        </Col>
      </Row>
      <Row className="mt-16">
        <Col>
          {filterButtons.map((btn) => (
            <Button
              variant="tab"
              key={btn.key}
              active={activeFilter === btn.key}
              data-key={btn.key}
              data-text={btn.text}
              onClick={onClickFilter}
              className="mr-8"
              data-testid={`btnStock-${btn.groupCode}`}
            >
              {btn.text}
            </Button>
          ))}
        </Col>
      </Row>
      <Row className="mt-16">
        <Col>
          <Scrollbars style={styles.dataContainer} autoHide className="table-shadow">
            <StickyTable stickyHeaderCount={1} className="use-custom-scrollbars">
              <StickyRow>
                {headers.map((c, idx) => (
                  <Cell className={c.className} key={c.text} style={{ width: c.width }}>
                    <Text size="table-header-regular" data-testid={`header-${idx}`}>
                      {c.text}
                    </Text>
                  </Cell>
                ))}
              </StickyRow>
              <DashboardStockContent
                results={results}
                header={headerContents}
                isNotation={isNotation}
              />
            </StickyTable>
          </Scrollbars>
        </Col>
      </Row>
    </>
  );
};

export default DashboardStock;
